import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DragulaModule } from 'ng2-dragula';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { MessageService } from 'primeng/api';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuardService } from './auth-guard.service';
import { AuthInterceptor } from './auth-interceptor';
import { ConfigService } from './config.service';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
import { PageNotFoundComponent } from './page-not-found.component';
import { SharedModule } from './shared/shared.module';
import { SpinnerService } from './ui/spinner.service';
import { UiModule } from './ui/ui.module';

registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LoginComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastModule,
    SharedModule,
    UiModule,
    AppRoutingModule,
    ScrollPanelModule,
    ModalModule.forRoot(),
    DragulaModule.forRoot(),
    PopoverModule.forRoot(),
    FontAwesomeModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, { provide: LOCALE_ID, useValue: 'de' },
  {
    provide: APP_INITIALIZER,
    useFactory: loadConfigurations,
    deps: [ConfigService],
    multi: true
  },
    AuthGuardService, LoginService, SpinnerService, MessageService],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function loadConfigurations(configService: ConfigService): () => {} {
  return () => configService.getConf();
}
